import { Terminal } from '@mui/icons-material';

export default Terminal;
